import { isAfter, isBefore } from 'date-fns';
import { XStack, YStack } from 'tamagui';

import type { Event } from '@/src/api/eventsApi';
import { formatSlotSummary } from '@/src/utils/dateFormatter';
import { openURL } from '@/src/utils/linkingUtils';
import PSIcon from './ui/PSIcon';
import PSLinkButton from './ui/PSLinkButton';
import PSText from './ui/PSText';
import EventLocation from './EventLocation';

export default function EventDetailMeta({ event }: { event: Event }) {
  let dateLine = '';
  if (event.nextBookableSlot) {
    dateLine = formatSlotSummary(
      event.nextBookableSlot,
      event.lastBookableSlot
    );
  } else if (event.slots.length > 0) {
    // Slot-less/cancelled events (see below) also land here with an empty
    // `slots` array — only reduce when there's actually something to reduce.
    const earliestSlot = event.slots.reduce((a, b) =>
      isBefore(a.startAt, b.startAt) ? a : b
    );
    const latestSlot = event.slots.reduce((a, b) =>
      isAfter(a.startAt, b.startAt) ? a : b
    );
    dateLine = formatSlotSummary(
      { startDatetime: earliestSlot.startAt },
      { startDatetime: latestSlot.startAt }
    );
  } else {
    dateLine = 'Already over!';
  }

  return (
    <YStack
      // borderWidth="$borderWidth.hairline"
      borderColor="$borderColor"
      rounded="$base"
      bg="$background"
      gap={'$space.sm'}
    >
      <PSText.Title>{event.title}</PSText.Title>
      <PSText.Body2>{dateLine}</PSText.Body2>
      <EventLocation
        venueName={event.venue.name}
        googleMapsUrl={event.venue.googleMapsUrl}
      />
    </YStack>
  );
}
